import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";

const pathNameMap = {
  "": "หน้าหลัก",
  buy: "รับซื้อ",
  create: "สร้าง",
  sale: "ขาย",
  customers: "รายชื่อลูกค้า",
  checkout: "จัดการบิล",
  customer_group: "จัดการกลุ่มลูกค้า",
  ticket: "จัดการบิล",
  edit: "แก้ไขข้อมูลลูกค้า",
  po_management: "จัดการใบเสนอราคา (PO)",
  so_management: "จัดการใบเสนอราคาขาย (SO)",
  po_create: "เปิดใบเสนอราคา (PO)",
  po_edit: "เปิดใบเสนอราคา (PO)",
  so_create: "เปิดใบเสนอราคา (SO)",
  so_edit: "เปิดใบเสนอราคา (SO)",
  stock: "สต๊อกสินค้า",
  transform: "แปรสภาพ",
  exchange: "เริ่มแปรสถาพ",
  inventory: "คลังสินค้า",
  reports: "รายงาน",
  purchases: "ยอดซื้อ",
  sales: "ยอดขาย",
  daily_purchases: "สรุปยอดซื้อประจำวัน",
  lock_pricing: "ประกันราคา",
  individual_purchases: "สรุปยอดซื้อสินค้ารายบุคคล",
  summary_purchases_product: "สรุปยอดซื้อสินค้ารายชนิด",
  summary_ticket_purchases: "สรุปยอดซื้อสินค้ารายบิล",
  cost_inventory: "ต้นทุนสินค้าคงเหลือ",
  daily_sales: "สรุปยอดขายประจำวัน",
  individual_sales: "สรุปยอดขายสินค้ารายบุคคล",
  summary_sales_product: "สรุปยอดขายสินค้ารายชนิด",
  summary_ticket_sales: "สรุปยอดขายสินค้ารายบิล",
  sales_quota: "สรุปโควต้าการซื้อขายสินค้า",
  "sale-customers": "ลูกค้าฝั่งขาย",
  edit_button: "จัดการปุ่มสินค้า",
  purchase_price: "รายละเอียดการรับซื้อ",

  top_monthly_purchases: "10 อันดับ ยอดซื้อรายบุคคลประจำเดือน",
  top_monthly_sales: "10 อันดับ ยอดขายรายบุคคลประจำเดือน",
};

const buyStatusMap = {
  waiting: "รอจ่าย",
  sent: "ส่งแล้ว",
  confirm: "ยืนยันแล้ว",
  payed: "จ่ายแล้ว",
  cancel: "ยกเลิก",
};

const saleStatusMap = {
  waiting: "รอขาย",
  sent: "ส่งแล้ว",
  confirm: "ยืนยันการขายแล้ว",
  payed: "รับเงินแล้ว",
  cancel: "ยกเลิก",
};

export default function AppBreadcrumbs({ poNumber }) {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get("status");
  const ticket = searchParams.get("ticket");
  const breadcrumbs = [];
  for (let i = 0; i < pathnames.length; i++) {
    const segment = pathnames[i];
    const to = `/${pathnames.slice(0, i + 1).join("/")}`;
    let label = pathNameMap[segment] || segment;
    if (segment === "po_edit" && poNumber) {
      const lastPart = poNumber.split("-").pop();
      label = `เปิดใบเสนอราคา (PO #${lastPart})`;
      breadcrumbs.push({ label, to, isLast: true });
      break;
    } else if (segment === "so_edit" && poNumber) {
      const lastPart = poNumber.split("-").pop();
      label = `เปิดใบเสนอราคา (SO #${lastPart})`;
      breadcrumbs.push({ label, to, isLast: true });
      break;
    }

    else if (segment === "ticket" && status) {
      const isSale = pathnames.includes("sale");
      const currentMap = isSale ? saleStatusMap : buyStatusMap;
      const displayStatus = currentMap[status] || status;
      label = `รายการบิล (${displayStatus})`;
      breadcrumbs.push({ label, to, isLast: true });
      break;
    } else if (segment === "checkout" && ticket) {
      const parts = ticket.split("-");
      const result = parts[parts.length - 1];

      const isSale = pathnames.includes("sale");
      const currentMap = isSale ? saleStatusMap : buyStatusMap;

      // เพิ่ม breadcrumb "กลับ"
      breadcrumbs.push({
        label: `รายการบิล (${currentMap[status] || status})`,
        to: "back",
        isLast: false,
      });

      label = `จัดการบิล #${result}`;
      breadcrumbs.push({ label, to, isLast: true });
      break;
    } else if (segment === "customer_group") {
      breadcrumbs.push({
        label,
        to,
        isLast: false,
      });

      if (pathnames[1]) {
        label = `ข้อมูลกลุ่มลุกค้า`;
        breadcrumbs.push({ label, to, isLast: true });
      }
      break;
    }

    breadcrumbs.push({ label, to, isLast: i === pathnames.length - 1 });
  }
  return (
    <nav className="flex items-center text-sm font-medium text-gray-500 mb-4" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        <li>
          <div className="flex items-center">
            <button
              onClick={() => navigate("/")}
              className="text-gray-400 hover:text-gray-600 transition-colors flex items-center"
            >
              <HomeIcon className="w-4 h-4 mr-1" fontSize="small" />
              <span className="hidden sm:inline">หน้าหลัก</span>
            </button>
          </div>
        </li>

        {breadcrumbs.map(({ label, to, isLast }, index) => (
          <li key={to || index}>
            <div className="flex items-center">
              <NavigateNextIcon className="w-4 h-4 text-gray-300 mx-1" fontSize="small" />
              {isLast ? (
                <span className="text-[#10B981] font-bold bg-green-50 px-2 py-0.5 rounded-md border border-green-100">
                  {label}
                </span>
              ) : (
                <button
                  onClick={() => {
                    if (to === "back") {
                      navigate(-1);
                    } else {
                      navigate(to);
                    }
                  }}
                  className="text-gray-500 hover:text-gray-800 hover:bg-gray-100 px-2 py-0.5 rounded-md transition-colors"
                >
                  {label}
                </button>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
